import { useEffect } from "react";

export function useLockBodyScroll(isLocked: boolean) {
	/** Effect */
	useEffect(() => {
		if (isLocked) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "auto";
		}
	}, [isLocked]);
}
